<script type="text/ecmascript-6">

    import { swiper, swiperSlide } from 'vue-awesome-swiper';

    export default {
        name: 'featured-artists',

        props: {
            data:{
                type:Object,
            }
        },

        components: {
            swiper,
            swiperSlide,
        },

        /**
         * The component's data.
         */
        data: () => ({
            artists: [],
            loading: false,
            swiperOption: {
                slidesPerView: 8,
                spaceBetween: 15,
                slidesPerGroup: 4,
                // loop: true,
                speed: 500,
                navigation: {
                    nextEl: '.swiper-button-next-artist',
                    prevEl: '.swiper-button-prev-artist',
                },
                breakpoints: {
                    2900: {
                        slidesPerView: 8,
                    },
                    1900: {
                        slidesPerView: 8,
                    },
                    1800: {
                        slidesPerView: 8,
                    },
                    1400: {
                        slidesPerView: 8,
                    },
                    1124: {
                        slidesPerView: 6,
                    },
                    1024: {
                        slidesPerView: 6,
                    },
                    992: {
                        slidesPerView: 6,
                    },
                    834: {
                        slidesPerView: 5,
                    },
                    768: {
                        slidesPerView: 5,
                        spaceBetween: 10,
                    },
                    640: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                        slidesPerGroup: 1,
                    },
                    375: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                        slidesPerGroup: 1,
                    }
                },
            },
        }),


        /**
         * Created the component.
         */
        created() {
        },

        mounted(){
            let _this = this;
            this.$nextTick(() => {
                _this.swiper.on('slideChange', function () {
                    if(!_this.isBeginning){
                        $('.swiper-button-prev-artist').removeClass('d-none');
                    }else{
                        $('.swiper-button-prev-artist').addClass('d-none');
                    }
                    if(!_this.isEnd){
                        $('.swiper-button-next-artist').removeClass('d-none');
                    }else{
                        $('.swiper-button-next-artist').addClass('d-none');
                    }
                });
            });
        },


        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            },
            isBeginning() {
                return this.swiper.isBeginning;
            },
            isEnd() {
                return this.swiper.isEnd;
            },
        },

        methods: {

        }

    }
</script>

<template>
    <div class="ms_featured_slider" v-show="data.data.length > 0">
        <div class="ms_heading">
            <h1>{{data.title}}</h1>
            <!-- <span class="veiw_all"><router-link to="/artists">view more</router-link></span> -->
        </div>

        <div class="row" v-show="loading">
            <div class="col-md-2" style="display: inline-block">
                <div class="load-music-box"></div>
            </div>

            <div class="col-md-2" style="display: inline-block">
                <div class="load-music-box"></div>
            </div>

            <div class="col-md-2" style="display: inline-block">
                <div class="load-music-box"></div>
            </div>

            <div class="col-md-2" style="display: inline-block">
                <div class="load-music-box"></div>
            </div>

            <div class="col-md-2" style="display: inline-block">
                <div class="load-music-box"></div>
            </div>

            <div class="col-md-2" style="display: inline-block">
                <div class="load-music-box"></div>
            </div>
        </div>

        <div v-show="!loading" class="ms_feature_slider swiper-container">
            <swiper :options="swiperOption" ref="mySwiper">
                <!-- slides -->
                <template v-for="artist in data.data">
                    <swiper-slide>
                        <div class="ms_rcnt_box">
                            <router-link tag="a" :to="{ name: 'artist', params: { id : artist.uuid }}" :title="artist.name_eng">
                                <div class="ms_rcnt_box_img ms_rcnt_box_img_rounded">
                                    <img :src="artist.image" alt="" alt="" onError="this.onerror=null;this.src='/images/album/Artist.png';">
                                    <!-- <img v-lazy="artist.image" alt=""> -->
                                    <div class="ms_main_overlay">
                                        <div class="ms_box_overlay"></div>
                                        <div class="ms_play_icon">
                                            <a href="javascript:;" @click.prevent="playAllArtistSong(artist.id)">
                                                <img src="/images/svg/play2.svg" alt="">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                            <div class="ms_rcnt_box_text text-center">
                                <h3><router-link tag="a" :to="{ name: 'artist', params: { id : artist.uuid }}">{{ artist.name }}</router-link></h3>
                            </div>
                        </div>
                    </swiper-slide>
                </template>

            </swiper>

        </div>
        <!-- Add Arrows -->
        <template v-if="data.data.length > 8">
            <div class="swiper-button-next-artist slider_nav_next"></div>
            <div class="swiper-button-prev-artist slider_nav_prev d-none"></div>
        </template>

    </div>
</template>
